/**
 * DevExtreme (esm/__internal/core/r1/config_provider.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import { BaseInfernoComponent } from "../../core/r1/runtime/inferno/index";
import { ConfigContext } from "./config_context";
export const ConfigProviderDefaultProps = {};
export let ConfigProvider = /*#__PURE__*/(() => {
  class ConfigProvider extends BaseInfernoComponent {
    constructor() {
      super(...arguments);
      this.__getterCache = {};
    }
    get config() {
      if (void 0 !== this.__getterCache.config) {
        return this.__getterCache.config;
      }
      return this.__getterCache.config = (() => ({
        rtlEnabled: this.props.rtlEnabled
      }))();
    }
    componentWillUpdate(nextProps) {
      if (this.props.rtlEnabled !== nextProps.rtlEnabled) {
        this.__getterCache.config = void 0;
      }
    }
    getChildContext() {
      return _extends({}, this.context, {
        [ConfigContext.id]: this.config || ConfigContext.defaultValue
      });
    }
    render() {
      return this.props.children;
    }
  }
  ConfigProvider.defaultProps = ConfigProviderDefaultProps;
  return ConfigProvider;
})();